module.exports = __webpack_public_path__ + "static/memory_img6@2x-810e95edacd585086fca25f61e9d81ba.png";